import desktopHeader from '../assets/image-header-desktop.jpg'
import mobileHeader from '../assets/image-header-mobile.jpg'

const images = {
    desktopHeader,
    mobileHeader
}

export default images